export default __webpack_public_path__ + "static/media/DSC_6191-min.083a2775.JPG";